import { render, staticRenderFns } from "./rebateAgreementAction.vue?vue&type=template&id=bffa2a7e&scoped=true"
import script from "./rebateAgreementAction.vue?vue&type=script&lang=js"
export * from "./rebateAgreementAction.vue?vue&type=script&lang=js"
import style0 from "./rebateAgreementAction.vue?vue&type=style&index=0&id=bffa2a7e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bffa2a7e",
  null
  
)

export default component.exports